import React, { useState, useEffect } from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    ScrollView,
    Image,
    ActivityIndicator,
    Linking,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import axios from 'axios';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/celerWebStyles';

export default function ListaProjetosWeb() {
    const navigation = useNavigation();
    const [analyses, setAnalyses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);

    const fetchAnaliseData = async (usuario_id) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://analise3.imogo.com.br/analises/usuario/${usuario_id}`);
            setAnalyses(response.data);
        } catch (error) {
            console.error('Erro ao buscar os dados do imóvel:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo?.id) {
            fetchAnaliseData(userInfo.id);
        }
    }, [userInfo]);

    const AnalysisCard = ({ id, date, status }) => {
        const getStatusText = (status) => {
            switch (status) {
                case 'em_progresso':
                    return 'Em Progresso';
                case 'concluida':
                    return 'Concluída';
                case 'pendente':
                    return 'Pendente';
                default:
                    return status;
            }
        };

        const handlePress = () => {
            if (status === 'pendente') {
                navigation.navigate('EtapasAnaliseWeb', {
                    usuario_id: userInfo.id,
                    analise_id: id,
                    status: 2,
                    id
                });
            } else {
                navigation.navigate('AnaliseDetalheWeb', {
                    usuario_id: userInfo.id,
                    id,
                });
            }
        };

        const formatDate = (dateString) => {
            const [year, month, day] = dateString.split('-');
            return `${day}/${month}/${year}`;
        };

        return (
            <View style={styles.optionButtonsContainer}>
                <TouchableOpacity style={styles.optionButton} onPress={handlePress}>
                    <Image
                        source={require('../../assets/icons/download.png')}
                        style={styles.optionIcon}
                    />
                    <View style={styles.optionTextContainer}>
                        <Text style={styles.optionTextTitle} allowFontScaling={false}>
                            Análise de certidões #{id}
                        </Text>
                        <Text
                            style={[styles.optionTextSubtitle, styles.cardStatus(status)]}
                            allowFontScaling={false}
                        >
                            {getStatusText(status)}
                            <Text style={styles.optionTextSubtitle} allowFontScaling={false}>
                                {' '}| {formatDate(date)}
                            </Text>
                        </Text>
                    </View>
                </TouchableOpacity>
            </View>
        );
    };

    return (
        <BaseWeb>
            {(user) => {
                if (!userInfo) setUserInfo(user);

                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Meus Projetos</Text>

                        <View style={styles.container}>
                            {loading ? (
                                <ActivityIndicator size="large" color="#730d83" style={{ marginTop: 30 }} />
                            ) : (
                                <Text style={[styles.checkboxLabel, { marginTop: 20 }]}>
                                    Nenhum projeto encontrado.
                                </Text>
                            )}
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
